import { useEffect, useState } from 'react'

import xor from 'lodash/xor'

import type Employee from 'modules/employees/store/models/Employee'
import type LeaveForm from 'modules/timeoff/lib/LeaveForm'

type IdsType = number[] | (number | null | undefined)

interface Props {
  form: LeaveForm
  currentEmployee: Employee | null | undefined
}
interface ReturnType {
  selectedIds: number[]
  disabled: boolean
  onSelect: (ids: IdsType) => void
}

const useSelectedEmployees = ({ form, currentEmployee }: Props): ReturnType => {
  const [selectedIds, setSelectedEmployees] = useState<any>([])
  const [disabled, setDisabled] = useState(!currentEmployee)

  const onSelect = (ids: IdsType) => {
    const field = form.get('employee_id')
    let selectedEmployeeIds = []

    if (ids instanceof Array) {
      selectedEmployeeIds = ids
    } else {
      selectedEmployeeIds = ids ? xor(selectedIds, [ids]) : []
    }

    setSelectedEmployees(selectedEmployeeIds)
    setDisabled(selectedEmployeeIds.length === 0)

    if (selectedEmployeeIds.length > 0) {
      field.set(selectedEmployeeIds[0])
    } else {
      field.set(null)
    }
  }

  const leaveTypeId = form.get('leave_type_id').value
  const policyId = form.get('policy_id').value
  useEffect(() => {
    setSelectedEmployees([])
  }, [leaveTypeId, policyId])

  return {
    disabled,
    onSelect,
    selectedIds,
  }
}

export default useSelectedEmployees
